import checkIcon from '@SvgIcon/checkmark.svg'
import cancelIcon from '@SvgIcon/close.svg'
import handleIcon from '@SvgIcon/grid.svg'
import trashIcon from '@SvgIcon/trash-b.svg'

import svgIconHtml from '../../svgIconHtml'

export default {
  name: 'UiFormRepeaterItem',

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  // language=HTML
  template: `
    <div class="form-repeater-item">
      <div class="form-repeater-item__sort-handle" v-if="sortable">
        ${svgIconHtml(handleIcon)}
      </div>
      <div class="form-repeater-item__actions">
        <slot name="actions">
          <button
            v-if="useEditMode && !editMode"
            type="button"
            class="clear button"
            @click="editMode = true"
          >
            Edit
          </button>

          <div v-if="!useEditMode || editMode" class="remove-action">
            <template v-if="pendingRemoval">
              <button
                type="button"
                class="clear button alert"
                @click="finishRemove"
              >
                ${svgIconHtml(checkIcon)}
              </button>
              <button
                type="button"
                class="clear button"
                @click="cancelRemove"
              >
                ${svgIconHtml(cancelIcon)}
              </button>
            </template>
            <button
              v-else
              type="button"
              class="clear button alert"
              @click="startRemove"
            >
              ${svgIconHtml(trashIcon)}
            </button>
          </div>
        </slot>
      </div>
      <div
        class="form-repeater-item__fields"
        :class="{ 'inline-fields': inlineFields, 'equal-children': equalChildren }"
      >
        <template v-if="!useEditMode">
          <slot name="edit" :item="modelValue"></slot>
        </template>
        <template v-else>
          <template v-if="editMode">
            <slot name="edit" :item="modelValue"></slot>
          </template>
          <template v-else>
            <slot name="render" :item="modelValue"></slot>
          </template>
        </template>
      </div>
    </div>
  `,

  props: {
    modelValue: {
      type: Object,
      required: true,
      // FormRepeater expects all items to have an `id` property.
      default() {
        return {
          id: null,
        }
      },
    },
    isNewItem: {
      type: Boolean,
      default: false,
    },
    inlineFields: {
      type: Boolean,
      default: false,
    },
    equalChildren: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    useEditMode: {
      type: Boolean,
      default: false,
    },
    defaultEditMode: {
      type: Boolean,
      default: false,
    },
    confirmDelete: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      editMode: this.isNewItem || this.defaultEditMode,
      pendingRemoval: false,
    }
  },

  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.$emit('update:modelValue', this.modelValue)
      },
    },
  },

  methods: {
    startRemove() {
      if (this.confirmDelete) {
        this.pendingRemoval = true
      } else {
        this.finishRemove()
      }
    },
    cancelRemove() {
      this.pendingRemoval = false
    },
    finishRemove() {
      this.$emit('remove', this.modelValue)
    },
    edit() {
      this.$emit('edit', this.modelValue)
    },
  },
}
